import React, { useState } from "react";
import { Menu, Row, Col } from "antd";
import { Route, Link, Switch, useLocation } from "react-router-dom";
import "./styles/setting.css";
import OrganisationIcon from "../../assets/icons/organisation@3x.png";
import ApprovalsIcon from "../../assets/icons/approvals@3x.png";
import CategoriesIcon from "../../assets/icons/Categories@3x.png";
import PathIcon from "../../assets/icons/Path@3x.png";
import Policies_LimitsIcon from "../../assets/icons/Policies_Limits@3x.png";
import Users_controlsIcon from "../../assets/icons/users_controls@3x.png";
import { hasAccess, hasCustomize, RouteConstants } from "../../utils";
import Roles from "./UsersControls/Roles/Roles";
import Grades from "./UsersControls/GradesDesignation/Grades";
import CustomField from "./UsersControls/CustomField/CustomField";
import Users from "./UsersControls/Users";
import Organisation from "./Organisation";
import Categories from "./Categories/Categories";
import Expense from "./PoliciesLimits/Expense/Expense";
import Cards from "./PoliciesLimits/Cards/Cards";
import ApprovalsReports from "./Approvals/ApprovalsReports";
import ApprovalAdvance from "./Approvals/ApprovalsAdvance";
import AddUsers from "./UsersControls/Users/AddUser";
import Expenses from "./Customisation/Expenses/Expenses";
import Reports from "./Customisation/Reports/Reports";
import Advances from "./Customisation/Advances/Advances";
import CostCenter from "./Customisation/CostCenter/CostCenter";
import Projects from "./Customisation/Projects/Projects";
import Trips from "./Customisation/Trips/Trips";
import Merchants from "./Customisation/Merchants/Merchants";
import ApprovalTrip from "./Approvals/AprrovalsTrip";
import ManageOrganization from "./Organisation/ManageOrganization";
import AddNewOrg from "./Organisation/AddNewOrg";

import HasPermissions from "./HasPermissions";

const { SubMenu } = Menu;
const rootSubmenuKeys = ["sub1", "sub2", "sub3", "sub4", "sub5", "sub6"];

const Settings = () => {
  const location = useLocation();
  const [openKeys, setOpenKeys] = React.useState(["sub2"]);
  const [key, setKey] = useState(null);

  const onOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
    if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
  };

  const handleMenuClick = (menuKey) => {
    if (location.pathname === RouteConstants.SETTING_USERS && menuKey === "2") {
      setKey(Date.now());
    }
  };

  const renderSettingMenu = () => {
    return (
      <Menu
        mode="inline"
        className="setting-nav"
        openKeys={openKeys}
        onOpenChange={onOpenChange}
        onClick={(e) => handleMenuClick(e.key)}
        style={{ width: 256, padding: "20px 0" }}
      >
        {hasAccess("organisation_settings", "read") && (
          <Menu.Item
            key="1"
            icon={
              <img src={OrganisationIcon} alt={"logo"} className="menu-logo" />
            }
          >
            <Link to={RouteConstants.SETTING_ORGANISATION} />
            Organisation Profile
          </Menu.Item>
        )}
        {/* <Menu.Item
          key="19"
          icon={
            <img src={OrganisationIcon} alt={"logo"} className="menu-logo" />
          }
        >
          <Link to={RouteConstants.SETTING_ORGANISATION_MANAGE} />
          Manage Branches
        </Menu.Item> */}
        {hasAccess("users_and_controls", "read") && (
          <SubMenu
            key="sub2"
            icon={
              <img
                src={Users_controlsIcon}
                alt={"logo"}
                className="menu-logo"
              />
            }
            title="Users & Controls"
          >
            <Menu.Item key="2">
              <Link
                to={{
                  pathname: RouteConstants.SETTING_USERS,
                  key: key,
                }}
              />
              Users
            </Menu.Item>
            <Menu.Item key="66">
              <Link
                to={{
                  pathname: RouteConstants.SETTING_CHECKERS,
                  key: key,
                }}
              />
              Corporate Checker
            </Menu.Item>
            <Menu.Item key="3">
              <Link to={RouteConstants.SETTING_ROLES} />
              Roles &amp; Permissions
            </Menu.Item>
            <Menu.Item key="4">
              <Link to={RouteConstants.SETTING_GRADES} />
              Grades &amp; Designations
            </Menu.Item>
            <Menu.Item key="5">
              <Link to={RouteConstants.SETTING_CUSTOM_FIELD} />
              Custom Fields
            </Menu.Item>
          </SubMenu>
        )}
        {hasAccess("categories", "read") && (
          <Menu.Item
            key="6"
            icon={
              <img src={CategoriesIcon} alt={"logo"} className="menu-logo" />
            }
          >
            <Link to={RouteConstants.SETTING_CATEGORIES} />
            Categories
          </Menu.Item>
        )}
        {hasAccess("policies_and_limits", "read") && (
          <SubMenu
            key="sub4"
            icon={
              <img
                src={Policies_LimitsIcon}
                alt={"logo"}
                className="menu-logo"
              />
            }
            title="Policies &amp; Limits"
          >
            <Menu.Item key="7">
              <Link to={RouteConstants.SETTING_POLICIES_EXPENSE} />
              Expense
            </Menu.Item>
            <Menu.Item key="8">
              <Link to={RouteConstants.SETTING_POLICIES_CARDS} />
              Cards
            </Menu.Item>
          </SubMenu>
        )}
        {hasAccess("approvals", "read") && (
          <SubMenu
            key="sub5"
            icon={
              <img src={ApprovalsIcon} alt={"logo"} className="menu-logo" />
            }
            title="Approvals"
          >
            <Menu.Item key="72">
              <Link to={RouteConstants.SETTING_APPROVALS} />
              Reports
            </Menu.Item>
            <Menu.Item key="82">
              <Link to={RouteConstants.SETTING_APPROVALS_TRIP} />
              Trips
            </Menu.Item>
            <Menu.Item key="822">
              <Link to={RouteConstants.SETTING_APPROVALS_ADVANCE} />
              Advances
            </Menu.Item>
          </SubMenu>
        )}
        {hasCustomize() && (
          <SubMenu
            key="sub6"
            icon={<img src={PathIcon} alt={"logo"} className="menu-logo" />}
            title="Customisation"
          >
            {hasAccess("expense_settings", "read") && (
              <Menu.Item key="71">
                <Link to={RouteConstants.SETTING_CUSTOMISATION_EXPENSES} />
                Expenses
              </Menu.Item>
            )}
            {hasAccess("reports_settings", "read") && (
              <Menu.Item key="72">
                <Link to={RouteConstants.SETTING_CUSTOMISATION_REPORTS} />
                Reports
              </Menu.Item>
            )}
            {hasAccess("advances_settings", "read") && (
              <Menu.Item key="93">
                <Link to={RouteConstants.SETTING_CUSTOMISATION_ADVANCES} />
                Advances
              </Menu.Item>
            )}
            {hasAccess("trips_settings", "read") && (
              <Menu.Item key="94">
                <Link to={RouteConstants.SETTING_CUSTOMISATION_TRIPS} />
                Trips
              </Menu.Item>
            )}
            {hasAccess("projects", "read") && (
              <Menu.Item key="95">
                <Link to={RouteConstants.SETTING_CUSTOMISATION_PROJECTS} />
                Projects
              </Menu.Item>
            )}
            {/* <Menu.Item key="97">
            <Link to={RouteConstants.SETTING_CUSTOMISATION_REIMBURSEMENTS} />
            Reimbursements
          </Menu.Item> */}
            {hasAccess("cost_center", "read") && (
              <Menu.Item key="931">
                <Link to={RouteConstants.SETTING_CUSTOMISATION_COSTCENTER} />
                Cost Center
              </Menu.Item>
            )}
            {/* {hasAccess("merchants", "read") && (
              <Menu.Item key="99">
                <Link to={RouteConstants.SETTING_CUSTOMISATION_MERCHANT} />
                Merchants
              </Menu.Item>
            )} */}
          </SubMenu>
        )}
      </Menu>
    );
  };

  return (
    <Row>
      <Col flex="256px">{renderSettingMenu()}</Col>
      <Col flex="1 1" style={{ width: "50%" }}>
        <div className="content-div">
          <Switch>
            <Route
              path="/setting/"
              exact
              component={() => (
                <HasPermissions
                  role={"organisation_settings"}
                  name="Organisation Profile"
                >
                  <Organisation />
                </HasPermissions>
              )}
            />
            <Route
              exact
              path="/setting/organisation/"
              component={() => (
                <HasPermissions
                  role={"organisation_settings"}
                  name="Organisation Profile"
                >
                  <Organisation />
                </HasPermissions>
              )}
            />
            <Route
              path="/setting/organisation/manage"
              component={() => <ManageOrganization />}
            />
            <Route
              path="/setting/organisation/add"
              component={() => (
                <HasPermissions
                  role={"organisation_settings"}
                  name="Organisation Profile"
                >
                  <AddNewOrg />
                </HasPermissions>
              )}
            />
            <Route path="/setting/users/" exact component={() => <Users />} />
            <Route
              path="/setting/checkers/"
              exact
              component={() => <Users checker={true} />}
            />
            <Route
              path="/setting/users/add_user/"
              component={() => <AddUsers />}
            />
            <Route path="/setting/roles/" component={() => <Roles />} />
            <Route path="/setting/grades/" component={() => <Grades />} />
            <Route
              path="/setting/custom_field/"
              component={() => <CustomField />}
            />
            <Route
              path="/setting/categories/"
              component={() => <Categories />}
            />
            <Route
              path="/setting/policies/expense/"
              component={() => <Expense />}
            />
            <Route
              path="/setting/policies/cards/"
              component={() => <Cards />}
            />
            <Route
              path="/setting/approvals/"
              component={() => <ApprovalsReports />}
            />
            <Route
              path="/setting/approvals_advance/"
              component={() => <ApprovalAdvance />}
            />
            <Route
              path="/setting/approvals_trip/"
              component={() => <ApprovalTrip />}
            />
            <Route
              path="/setting/customisation/"
              exact
              component={() => <Expenses />}
            />
            <Route
              path="/setting/customisation/expenses/"
              component={() => <Expenses />}
            />
            <Route
              path="/setting/customisation/reports/"
              component={() => <Reports />}
            />
            <Route
              path="/setting/customisation/advances/"
              component={() => <Advances />}
            />
            <Route
              path="/setting/customisation/trips/"
              component={() => <Trips />}
            />
            <Route
              path="/setting/customisation/projects/"
              component={() => <Projects />}
            />
            {/* <Route
              path="/setting/customisation/reimbursements/"
              component={() => <Reimbursements />}
            /> */}
            <Route
              path="/setting/customisation/cost_center/"
              component={() => <CostCenter />}
            />
            <Route
              path="/setting/customisation/merchant/"
              component={() => <Merchants />}
            />
          </Switch>
        </div>
      </Col>
    </Row>
  );
};

export default Settings;
